<template>
  <line-link
    v-bind="$attrs"
    :class="bem({ theme, 'disable-underline': disableUnderline })"
  >
    <slot />
  </line-link>
</template>

<script>
export default {
  name: 'SecondaryLineLink',

  props: {
    theme: {
      type: String,
      default: 'default',
      validator (value) {
        return ['default', 'gold', 'green'].includes(value)
      }
    },
    disableUnderline: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    return {
      bem: useBEM('SecondaryLineLink')
    }
  }
}
</script>

<style lang="postcss">
.SecondaryLineLink {
  &.LineLink::after {
    @apply t-gradient;
    background-clip: initial;
    -webkit-background-clip: initial;
    transition: opacity 0.3s ease-in-out;
    opacity: 0.5;

    .is-dark-chrome-theme & {
      @apply bg-gradient;
    }
  }

  &:hover::after {
    opacity: 1;
  }

  .LineLink__text {
    padding-top: 1px;

    .is-dark-chrome-theme & {
      @apply t-gradient-chrome;
    }
  }

  &--theme-default {
    .LineLink__text {
      @apply t-gradient;
    }
  }

  &--theme-gold {
    &.LineLink::after {
      background-image: var(--gradient-gold);
    }

    .LineLink__text {
      @apply t-gradient-gold;
    }
  }

  &--theme-green {
    &.LineLink::after {
      @apply bg-none bg-green;
    }

    .LineLink__text {
      @apply text-green;
    }
  }

  &--disable-underline {
    &.LineLink::after {
      @apply content-none;
    }
  }
}
</style>
